import actionWrapper from '../../lib/actionWrapper';
import axios from '../../lib/api';
import {OrganizationDto} from '../type/dtos/Organization';

export default {
    namespace: 'organization',

    state: {
        organizations: null,
    },

    effects: (dispatch: any) => ({
        fetchOrganizations() {
            return actionWrapper(
                 () => axios.get('organization')
                     .then((res) => {
                         dispatch.organization.fetchOrganizations_reducer(res?.data);
                         return res;
                     }),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        createOrganization(data: OrganizationDto) {
            return actionWrapper(
                () => axios.post('organization', data),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
    }),

    reducers: {
        fetchOrganizations_reducer(state: any, payload: any) {
            return {...state, organizations: payload};
        },
    },
};
